module.exports = __webpack_public_path__ + "img/head-side-headphones.5545768f.svg";